import React, { FC, ReactNode, useEffect } from "react";
import { useSelector } from "react-redux";
import { stepSelector } from "../../store/engine/engine.selectors";
import { Support } from "../Support";
import { Footer } from "../Footer";
import { IntermediarioDetails } from "../IntermediarioDetails";
import { Container } from "@material-ui/core";
import { Logo } from "../Logo";
import { stepSubTitles, stepTitles } from "../../config/stepTitles";
import { Title } from "../Title";
import { SubTitle } from "../SubTitle";
import { ResponsiveGrid } from "../ResponsiveGrid";
import { useLocation } from "react-router-dom";

interface Props {
  children: ReactNode;
}

export const Layout: FC<Props> = (props: Props) => {
  const step = useSelector(stepSelector);
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Container>
      <Logo showMenuButton={false} />
      <ResponsiveGrid>
        <Title title={stepTitles[step]} />
        <SubTitle title={stepSubTitles[step]} />
      </ResponsiveGrid>
      <ResponsiveGrid>{props.children}</ResponsiveGrid>
      <IntermediarioDetails />
      <Support />
      <Footer />
    </Container>
  );
};
